import $axios from "../../api";
import Swal from "sweetalert2";

const PREFIX = "member-tier/";
const MISSION_PREFIX = "pointsetting/missions/";

const state = () => ({
  // Tier Setting
  data: null,
  isLoading: false,
  isSaving: false,
  isSuccess: false,
  errors: null,

  // Missions / Events / Tier Bonus / Yearly
  missionList: [],
  missionDetail: null,
  missionLoading: false,
  missionSaving: false,
  missionErrors: null,
});

const mutations = {
  // Tier Setting
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_SAVING(state, payload) {
    state.isSaving = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_DATA(state, payload) {
    state.data = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },

  // Mission
  SET_MISSION_LOADING(state, payload) {
    state.missionLoading = payload;
  },
  SET_MISSION_SAVING(state, payload) {
    state.missionSaving = payload;
  },
  SET_MISSION_LIST(state, payload) {
    state.missionList = payload;
  },
  SET_MISSION_DETAIL(state, payload) {
    state.missionDetail = payload;
  },
  SET_MISSION_ERRORS(state, payload) {
    state.missionErrors = payload;
  },
};

const actions = {
  // ============================================================
  // 🔵 TIER SETTING
  // ============================================================

  /** GET Tier Settings */
  async getTierSetting({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      const { data } = await $axios.get(`${PREFIX}setting`);
      commit("SET_DATA", data.data);
      commit("SET_SUCCESS", true);
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response?.data);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  /** UPDATE Tier Settings */
  async updateTierSetting({ commit, dispatch }, payload) {
    commit("SET_SAVING", true);
    try {
      const { data } = await $axios.post(`${PREFIX}setting/update`, payload);

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: data.message || "Tier settings updated successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      return data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    } finally {
      commit("SET_SAVING", false);
    }
  },

  // ============================================================
  // 🔶 MISSION / EVENT / TIER BONUS / YEARLY
  // ============================================================

  /** LIST BASED ON CATEGORY */
  async getMissionList({ commit, dispatch }, category) {
    commit("SET_MISSION_LOADING", true);
    try {
      const { data } = await $axios.get(`${MISSION_PREFIX}${category}`);
      commit("SET_MISSION_LIST", data.data);
    } catch (error) {
      commit("SET_MISSION_ERRORS", error.response?.data);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_MISSION_LOADING", false);
    }
  },

  /** GET DETAIL */
  async getMissionDetail({ commit, dispatch }, id) {
    commit("SET_MISSION_LOADING", true);
    try {
      const { data } = await $axios.get(`${MISSION_PREFIX}detail/${id}`);
      commit("SET_MISSION_DETAIL", data.data);
    } catch (error) {
      commit("SET_MISSION_ERRORS", error.response?.data);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_MISSION_LOADING", false);
    }
  },

  /** CREATE / UPDATE MISSION */
  async saveMission({ commit, dispatch }, payload) {
    commit("SET_MISSION_SAVING", true);
    try {
      const url = payload.id
        ? `${MISSION_PREFIX}update/${payload.id}`
        : `${MISSION_PREFIX}create/${payload.category}`;

      const { data } = await $axios.post(url, payload);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: data.message || "Saved successfully!",
        timer: 1800,
        showConfirmButton: false,
      });

      return data;
    } catch (error) {
      commit("SET_MISSION_ERRORS", error.response?.data);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    } finally {
      commit("SET_MISSION_SAVING", false);
    }
  },

  /** DELETE */
  async deleteMission({ commit, dispatch }, id) {
    try {
      const { data } = await $axios.delete(`${MISSION_PREFIX}delete/${id}`);

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Entry berhasil dihapus",
        timer: 1500,
        showConfirmButton: false,
      });

      return data;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      throw error;
    }
  },
};

const getters = {
  tierSetting: (state) => state.data,
  isTierLoading: (state) => state.isLoading,
  isTierSaving: (state) => state.isSaving,
  tierErrors: (state) => state.errors,

  missionList: (state) => state.missionList,
  missionDetail: (state) => state.missionDetail,
  isMissionLoading: (state) => state.missionLoading,
  isMissionSaving: (state) => state.missionSaving,
  missionErrors: (state) => state.missionErrors,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
